
function About_us() {
  return (
    <div>
        <div class="row">
            <div class="col-lg-12">
                <h1 class="page-header">عنا</h1>
                <ol class="breadcrumb">
                    <li><a href="/">الرئيسية &gt;&gt; </a>
                    </li>
                    <li class="active">عنا</li>
                </ol>
            </div>
        </div>
        
        <div class="row">
            <div class="col-md-8">
                <h3> شرح موجز لكيفية استخدام الموقع الالكتروني المبتكر green journals </h3>
                <iframe width="709" height="399" src="https://www.youtube.com/embed/a9hnrpxoy30" title="شرح موجز لكيفية استخدام الموقع الالكتروني المبتكر green journals" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="col-md-4">
            </div>
        </div>

        <hr />
        
        <footer>
            <div class="row">
                <div class="col-lg-3">
					<div style={{"float" : "left", "padding-right" : "10px"}}>
                        <img src="img/img.png" class="img-thumbnail img-circle elevation-2" style={{"width" : "120px", "height" : "120px"}} />
                    </div>
					<div style={{"float" : "left", "text-align" : "left"}}>
						<p>Copyright &copy; <br /> 2020 - 2024</p>
					</div>
                </div>
                <div class="col-lg-4">
                    <div style={{"float" : "left", "padding-right" : "10px"}}>
                        <img src="uploads/img01.jpg" class="img-thumbnail img-circle elevation-2" style={{"width" : "120px", "height" : "120px"}} />
                    </div>
					<div style={{"float" : "left", "text-align" : "left"}}>
                        Prof. ADALA Laadjal <br /> Founder and Director of <br /> the Green journals Platform
                    </div>
                </div>
                <div class="col-lg-4">
					<div style={{"float" : "left", "padding-right" : "10px"}}>
						<a target="_blank" href="https://www.facebook.com/abgrcs/">
                            <img src="uploads/img02.jpg" class="img-thumbnail img-circle elevation-2" style={{"width" : "120px", "height" : "120px"}} />
                        </a>
					</div>
					<div style={{"float" : "left", "text-align" : "left"}}>
						<a target="_blank" href="https://www.facebook.com/abgrcs/">GHRICI Abdellah</a>
						<p>Technical Supervisor</p>
					</div>
                </div>
            </div>
        </footer>
    </div>
  );
}

export default About_us;
